module.exports = __webpack_public_path__ + "img/Frame 13.54366a85.png";